import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-diag-management',
  templateUrl: './diag-management.component.html',
  styleUrls: ['./diag-management.component.scss']
})
export class DiagManagementComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
